import '../shared/config/dependencies';
import App from './app/app';
import client from '../shared/api/ApolloClient';
import { ApolloProvider } from '@apollo/client';
import { Provider as StoreProvider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { store } from '../shared/store/store';

// App entrypoint

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);
root.render(
  <ApolloProvider client={client}>
    <StoreProvider store={store}>
      <App />
    </StoreProvider>
  </ApolloProvider>
);
